<template>
  <div class="devOps_producerSpaceProjectReport" v-loading="loading">
    <!-- #region 表单搜索部分 -->
    <el-form ref="form" class="form_warp" inline size="mini" :model="form" label-width="100px">
      <el-form-item label="项目体系" prop="deptName" :label-width="formLabelWidth">
        <el-select size="mini" :style="iptStyle" v-model="form.systemId" collapse-tags filterable
                   placeholder="请选择项目体系" clearable>
          <el-option v-for="(key, value) in allSystem" :key="key" :label="key" :value="value"/>
        </el-select>
      </el-form-item>
      <el-form-item label="项目名称" prop="teamId" :label-width="formLabelWidth">
        <el-select size="mini" :style="iptStyle" v-model="form.projectName" collapse-tags filterable
                   placeholder="请选择项目" clearable>
          <el-option v-for="item in projectList" :key="item.id" :label="item.projectName" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="需求名称">
        <el-input :style="iptStyle" placeholder="请输入" v-model="form.demandName" />
      </el-form-item>
      <el-form-item label="产品经理" prop="ownerId" :label-width="formLabelWidth">
        <el-select :style="iptStyle" filterable  clearable collapse-tags size="mini" v-model="form.pmId"  placeholder="请选择">
          <el-option v-for="(key, value) in allUser" :key="key" :label="key" :value="value" />
        </el-select>
      </el-form-item>
      <el-form-item label="需求状态" prop="ownerId" :label-width="formLabelWidth">
        <el-select :style="iptStyle" multiple filterable collapse-tags  v-model="form.demandStatus"
                   placeholder="请选择需求状态">
          <el-option v-for="(value, key) in allStatusList.ALLSTATUSTYPE2" :key="key" :label="value.value" :value="value.key" />
        </el-select>
      </el-form-item>
      <el-form-item label="计划上线日期">
        <el-date-picker
            v-model="form.serach_plan_time"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="-"
            start-placeholder="起始日期"
            end-placeholder="截止日期" />
      </el-form-item>
      <el-form-item label="实际上线日期">
        <el-date-picker
            v-model="form.serach_real_time"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="-"
            start-placeholder="起始日期"
            end-placeholder="截止日期" />
      </el-form-item>
      <el-form-item label="创建需求日期">
        <el-date-picker
            v-model="form.serach_demand_time"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="-"
            start-placeholder="起始日期"
            end-placeholder="截止日期" />
      </el-form-item>
      <div style="width: 100%;">
        <el-form-item class="chooseTime" style="width: 100%;">
          <el-button style="margin-left:32px;letter-spacing: 2px;font-weight: bold;font-size: 12px;" type="primary"
                     @click="formSearch('reset','search')">查询
          </el-button>
          <el-button @click.stop="searchTime(1)"  size="mini">过去一周</el-button>
          <el-button @click.stop="searchTime(2)" size="mini">过去两周</el-button>
          <el-button @click.stop="searchTime(3)" size="mini">过去一个月</el-button>
          <el-button @click.stop="searchTime(4)" size="mini">过去三个月</el-button>
          <el-button @click.stop="searchTime(5)" size="mini">过去半年</el-button>
          <el-button @click.stop="searchTime(6)" size="mini">过去一年</el-button>
          <div v-show="isShowChart" @click="isShowChart = false" class="el-icon-arrow-up" style="color: #409EFF;text-align: right;cursor: pointer;font-size: 14px;font-weight: bold;position: absolute;right:32px;"><span>收起</span></div>
          <div v-show="!isShowChart" @click="isShowChart = true" class="el-icon-arrow-down" style="color: #409EFF;text-align: right;cursor: pointer;font-size: 14px;font-weight: bold;position: absolute;right:32px;"><span>展开</span></div>

        </el-form-item>
      </div>
    </el-form>

    <div v-show="isShowChart">
      <el-row :gutter="5" class="chart_row">
        <el-col :span="6">
          <div class="chart_single_div">
            <div ref="myChartPie1" id="myChartPie1"></div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="chart_single_div">
            <div ref="myChartPie2" id="myChartPie2"></div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="chart_single_div">
            <div ref="myChartPie3" id="myChartPie3"></div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="chart_single_div">
            <div ref="myChartPie4" id="myChartPie4"></div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- #endregion 表单搜索部分 -->
    <!-- #region 表格部分 -->
    <div :class="[isShowChart ? 'project-box' : 'project-box-c']">
      <el-table height="100%" stripe :header-cell-style="getCellClass" border row-key="id" ref="multipleTable" :expand-row-keys="expands" @row-click="clickRowHandle" style="margin-top:0;" :cell-style="getRowClass"
                @sort-change="sortChange" :data="tableData" :tree-props="{children: 'children', hasChildren: 'hasChildren'}" @expand-change="showDetailData" :span-method="arraySpanMethod">
        <el-table-column  prop="dps_name_zh"  align="center" width="120" fixed="left" label="项目体系" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="dp_name" align="center" label="项目名称" fixed="left"  :show-overflow-tooltip="true" width="160">
          <template slot-scope="scope">
            <span v-if="scope.row.type === 'parent'"  class="table_text_click_new" @click="linkFrom(11, 'proId',scope.row.dp_id)">{{scope.row.dp_name}}</span>
            <span v-else-if="scope.row.type === 'children'"  class="table_text_click_new" @click="linkFrom(9, 'tid',scope.row.taskId)">{{scope.row.dp_name}}</span>
            <span v-else>{{scope.row.dp_name}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="dd_name" align="center"  min-width="160" label="需求名称" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.type === 'parent'"  class="table_text_click_new" @click="linkFrom(3, 'pid',scope.row.dd_id)">{{scope.row.dd_name}}</span>
            <span v-else>{{scope.row.dd_name}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="demander_username" align="center" label="需求人员" :show-overflow-tooltip="true" width="120">
        </el-table-column>
        <el-table-column prop="pm_username" align="center" label="产品经理" :show-overflow-tooltip="true" width="120">
        </el-table-column>
        <el-table-column prop="reviewer_username" align="center" label="技术负责人" :show-overflow-tooltip="true" width="120">
        </el-table-column>
        <el-table-column prop="status_desc"  align="center" width="80" label="需求状态" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="expect_finish_date" align="center" width="120" label="期望上线日期" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="plan_finish_date" align="center" width="120" label="计划上线日期" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="finish_date" align="center" width="120" label="" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="developer_delay"  align="center" width="120" label="实际上线日期" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="progress_rate" align="center" width="120" label="" :show-overflow-tooltip="true">
        </el-table-column>
        <!-- <el-table-column prop="emp1" label="任务延期率" width="100" align="center" :show-overflow-tooltip="true">
        </el-table-column> -->
        <el-table-column prop="emp2" align="center" width="120" label="" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="emp3" label="" width="120" align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="emp4" label="需求进度" width="120" align="center" :show-overflow-tooltip="true">
        </el-table-column>
      </el-table>
    </div>
    <!-- #endregion 表格部分 -->
    <!-- #region 分页部分 -->
    <div class="block devOpsSpace_page">
      <span class="demonstration">当前页{{ currentPageLength || 0 }}条</span>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="[10, 25, 50, 100]"
                     layout="total, prev, pager, next, sizes" :total="count">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  getDevOpsSpaceProducerListApi,
  getDevOpsSpaceNewReviewListApi,
  getDevOpsSpaceDailyTaskReportListApi,
  getDevOpsSpaceTeamListApi,
  getDevOpsSpacePerformanceDetailListApi,
  getDevOpsSpaceDailyTaskReportDetailApi,
  getDevOpsSpaceFindProjectNameApi,
  getDevOpsSpaceProjectPerformanceListApi,
  getDevOpsSpaceProjectPerformanceDetailApi, getDevOpsSpaceProjectPerforchartDetailApi
} from "@/server/tops/devOps";
import { formatEnToUtf8, formatTimeToDate, formatEnToUtf8NoEn } from "@/views/tops/devOps/components/util.js";
import { getStorage, setStorage } from "@/common/utils/storage.js"
import Menu from '@/components/menu/index.vue'
import { mapState, mapMutations } from 'vuex';
import Review from '@/views/tops/devOps/producerSpace/review.vue'
import CreateProject from "@/views/tops/devOps/producerSpace/components/createProject.vue";
import RecordProject from "@/views/tops/devOps/producerSpace/components/recordProject.vue";
import {getDevOpsSpaceAllUserListApi, getDevOpsSpaceSystemApi} from "@/server/tops/base";
import * as echarts from "echarts";
export default {

  components: { },
  props: {
    tabid: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // 表单搜索条件
      form: {
        serach_plan_time:'',
        serach_real_time:'',
        serach_demand_time:'',
        systemId:'',
        projectName:'',
        demandName:'',
        pmId:'',
        demandStatus:[],
        planStartDate:'',
        palnEndDate:'',
        StartDate:'',
        EndDate:'',
        createStartDate:'',
        createEndDate:'',

      },
      // 需求列表
      tableData: [],
      tableDataAll:[],
      // input 搜索样式
      iptStyle: {
        width: '180px'
      },
      // 弹出层部分
      dialogVisible: {
        demand: false,
        task: false,
        toDevelop: false,
        developing: false,
        toTest: false,
        testEnvTesting: false,
        preEnvTesting: false,
        uatTesting: false,
        toRelease: false,
        proEnvTesting: false,
        online: false,
        project: false,
        record: false,
      },
      // 选中信息
      checkedInfo: {},
      cacheTableData: [],
      count: 10, // 总计
      currentPage: 1, // 当前页
      currentPageLength: 10,
      pageSize: 10, // 每页多少个
      expands: [],
      preciseSwitch: false,
      users: {},
      loading:false,
      tableLoading: false,
      checkedTables: ['reviewed_status','o_aelt', 'o_pdt', 'project_system', 'demander', 'user_pm', 'priority', 'p_status', 'p_issue_status', 'plt', 'progress', 'taskInfo.module', 'taskInfo.user_rd', 'taskInfo.user_qa', 'taskInfo.status', 'taskInfo.task_progress', 'taskInfo.issue'],
      back : '',
      teamList:[],
      allUser: {},
      allSystem: [],
      projectList:[],
      isShowChart:true,
    };
  },
  async created() {
    await this.$store.dispatch('getDevopsSelect')
    await this.$store.dispatch('getDevopsStatusList',{type:''})
    let checkedTables = getStorage('checkedTables', 'localStorage')
    let pageSize = getStorage('pageSize', 'localStorage')
    pageSize && (this.pageSize = pageSize * 1);
    this.checkedTables = checkedTables ? checkedTables.split(',') : this.checkedTables;

  },
  computed: {
    ...mapState(
        {
          // 进度条
          allSelect: (state) => state.devOps.ALLSELECT,
          allUserList: (state) => state.devOps.NEWALLUSERLIST,
          allStatusList: (state) => state.devOps.NEWALLSTATUSLIST,
          NEWREVIEWSTATUS: (state) => state.devOps.NEWREVIEWSTATUS,
          allMenuList: (state) => state.devOps.NEWALLMENULIST,
          NEWTEXTORGSCHART: (state) => state.devOps.NEWTEXTORGSCHART,
        }
    ),
    /*评审状态*/
    reviewedStr() {
      let str = ''
      this.form.reviewed_status.forEach(item => {
        str += this.allSelect.TEXTREVIEWSTATUS[item] + ' '
      })
      return str;
    },
    /*需求状态 */
    pStrStatus() {
      let str = ''
      this.form.p_status.forEach(item => {
        str += this.allSelect.TEXTPISSUESTATUS[item] + ' '
      })
      return str;
    },
  },
  watch: {
    'tableData': {
      handler() {
        this.$nextTick(() => {
          // this.$refs.multipleTable.doLayout()
        })
      },
      deep: true
    }
  },
  async mounted() {
    const { pid = '', proId = '' } = this.$route.query;
    const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
    //this.form = { ...this.form, user: username ? [username] : [], title: pid, reviewer: username};
    if (pid || proId ) {
      this.form.status = '';
      this.form.reviewId = '';
      if(pid) this.form.demandName = pid;
      if(proId) this.form.projectName = proId;
    }
    let nowday = new Date().getDay();
    //let day = nowday || 7;
    let day = 1;
    let start_date = new Date(this.$moment(new Date()).format("YYYY-MM-DD")).getTime() - 60 * 60 * 24 * 1000*day;
    let end_date = start_date;
    let c_day = new Date(start_date).getDay();
    if(c_day === 0 ){
      day = 3;
      start_date = new Date(this.$moment(new Date()).format("YYYY-MM-DD")).getTime() - 60 * 60 * 24 * 1000*day;
      end_date = start_date;
    }else if(c_day === 6){
      day = 2;
      start_date = new Date(this.$moment(new Date()).format("YYYY-MM-DD")).getTime() - 60 * 60 * 24 * 1000*day;
      end_date = start_date;
    }


    //this.form.startDate = this.formatDate(start_date);
    //this.form.endDate = this.formatDate(end_date);
    //this.form.serach_time = [this.form.startDate,this.form.endDate];

    this.$nextTick(async () => {
      await this.getSystem();
      await this.getProjectList();
      await this.getDevOpsSpaceAllUser();
      await this.formSearch();
      //await this.getChartData();
      // this.autoDialogDetailPop(this.tableData)
    })
  },
  methods: {
    ...mapMutations(['filterSelect']),
    formatDate(time) {
      let date = new Date(time);
      let myyear = date.getFullYear();
      let mymonth = date.getMonth() + 1;
      let myweekday = date.getDate();
      if (mymonth < 10) {
        mymonth = '0' + mymonth;
      }
      if (myweekday < 10) {
        myweekday = '0' + myweekday;
      }
      return (myyear + '-' + mymonth + '-' + myweekday);
    },
    // 扩展行
    clickRowHandle(row, column, event) { },
    // 表单搜索
    async formSearch(type,key) {
      this.form.planStartDate='';
      this.form.palnEndDate='';
      this.form.StartDate='';
      this.form.EndDate='';
      this.form.createStartDate='';
      this.form.createEndDate='';
      if(this.form.serach_plan_time){
        if(this.form.serach_plan_time[0]){
          this.form.planStartDate=this.form.serach_plan_time[0];
        }
        if(this.form.serach_plan_time[1]){
          this.form.palnEndDate=this.form.serach_plan_time[1];
        }
      }
      if(this.form.serach_real_time){
        if(this.form.serach_real_time[0]){
          this.form.StartDate=this.form.serach_real_time[0];
        }
        if(this.form.serach_real_time[1]){
          this.form.EndDate=this.form.serach_real_time[1];
        }
      }
      if(this.form.serach_demand_time){
        if(this.form.serach_demand_time[0]){
          this.form.createStartDate=this.form.serach_demand_time[0];
        }
        if(this.form.serach_demand_time[1]){
          this.form.createEndDate=this.form.serach_demand_time[1];
        }
      }
      if (key === 'domain') {
        this.filterSelect({ type: 'domain_module', val: this.form.domain })
      }
      if(type === 'reset'){
        this.pageNo = 1;
        this.currentPage = 1;
      }
      try {
        let params = {};
        for (const key in this.form) {
          const val = this.form[key];
          params[key] = this.$SELFTYPEJUDGE.isArray(val) ? val.toString() : val;
        }
        params.pageNo = this.currentPage
        params.pageSize = this.pageSize
        this.loading = true;
        const ret = await getDevOpsSpaceProjectPerformanceListApi(params);
        this.tableData =   this.formatTableData(ret.data);
        this.cacheTableData = this.formatTableData(ret.data);
        this.currentPageLength = ret.data.length;
        this.count = ret.count;
        await this.getChartData(params);
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        })
      } finally {
        this.loading = false;
      }
      this.allPack();
      return false;
    },
    // 全部收起
    allPack() {
      const list = document.querySelectorAll(".el-table__expand-icon");
      for (let i = 0; i < list.length; i++) {
        if (!list[i].className.includes("el-table__expand-icon--expanded")) {
          continue;
        } else {
          list[i].click();
        }
      }
    },
    ShowChart(isShow){
      console.log(99999)
    },
    // 判断是否需要直接弹详情
    autoDialogDetailPop(tableData) {
      const { pid = '', tid = '', sid = '' } = this.$route.query;
      if (!tableData.length) return;
      if (pid && !tid && !sid) { // 弹需求详情
        this.showDialogVisible('demand', tableData[0])
        return;
      }
      if (pid && tid && !sid) { // 弹任务详情
        this.showDialogVisible('task', tableData[0])
        return;
      }
      if (pid && tid && sid) { // 弹阶段详情
        this.showDialogVisible(this.allSelect.TEXTTASKSTATUSDIOLOGVISIBLE[tableData[0].taskInfo.status], tableData[0])
        return;
      }
      return;
    },
    // 格式化数据
    formatTableData(data) {
      let arr = []
      data.forEach((o,i) => {
        let developer_delay = 0;
        let tmp_id = 0;
        if(o.tmp_id){
          tmp_id = o.tmp_id;
        }
        if(o.developer_delay){
          developer_delay = o.developer_delay;
        }
        const obj = { ...o, demander_username:o.demander.nameZh?o.demander.nameZh:'', reviewer_username:o.reviewer.nameZh?o.reviewer.nameZh:'', pm_username:o.pm.nameZh?o.pm.nameZh:'',children:[{
            id: i + '-' + o.dd_id,
          }],id:o.dd_id,developer_delay:developer_delay + '/'+tmp_id,progress_rate:o.progress_rate + '%',type:'parent'};
        arr.push(obj)
      })
      return arr;
    },
    changeTableData(data) {
      let arr = []
      data.forEach(o => {
        const obj = { p_issue_status: o.p_status, ...this.commonTableDataObj(o),taskFinishCount: o.taskFinishCount + '/' +  o.taskCount};
        arr.push(obj)

      })
      return arr;
    },
    // 公共部分逻辑
    commonTableDataObj(o) {
      const { owner, deptName, teamName, submit_date, taskCount, taskFinishCount, estimateWorkHour ,submitWorkHour,submitBugHour} = o;
      return { owner, deptName, teamName, submit_date, taskCount, taskFinishCount, estimateWorkHour ,submitWorkHour,submitBugHour };
    },
    getCellClass(row, column, rowIndex, columnIndex) {
      if(row.columnIndex === 17){
        //console.log(row.row[3].rowSpan)
        // row.row[3].rowSpan = 2;
        //return "display:none";
      }
      if(row.columnIndex === 8 || row.columnIndex === 10  || row.columnIndex === 12){
        return "border:none;padding: 4px 0; height:36px;background:#f3f3f3;color:#909399;font-size:14px;position: relative;right: -50px;z-index: 99;"
      }
      if(row.columnIndex === 14){
        return "border:none;padding: 4px 0; height:36px;background:#f3f3f3;color:#909399;font-size:14px;"
      }
      if(row.columnIndex === 15){
        return "padding: 4px 0;height:36px;background:#f3f3f3;color:#909399;font-size:14px;position: relative;left: -60px;z-index: 99;"
      }
      return "padding: 4px 0;height:36px;background:#f3f3f3;color:#909399;font-size:14px;"
    },

    // 表格样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if(columnIndex == 0 || columnIndex == 1){
        return "border-top:1px solid #EBEEF5;font-size: 12px;font-weight: bold;padding:6px 0;";
      }
      if(!row.children && row.header && columnIndex == 2){
        return "border-top:1px solid #EBEEF5;font-size: 12px;font-weight: bold;padding:6px 0;text-align:right;";
      }
      if(row.type=== 'children' && columnIndex === 2){
        return "border-top:1px solid #EBEEF5;font-size: 12px;padding:6px 0;text-align:right;";
      }
      if(!row.children && row.header){
        return "border-top:1px solid #EBEEF5;font-size: 12px;font-weight: bold;padding:6px 0;";
      }
      return "border-top:1px solid #EBEEF5;font-size: 12px;padding:6px 0;";
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (row.children) {
        if (columnIndex === 8 || columnIndex === 9 || columnIndex === 10 || columnIndex === 11) {
          return [1, 2];
        } else if (columnIndex === 12 || columnIndex === 13|| columnIndex === 14|| columnIndex === 15) {
          return [0, 0];
        }
        /*if(columnIndex == 2 || columnIndex == 11 || columnIndex == 12 || columnIndex == 13){
         // return [1,2];
        }*/
      }
      if(!row.children){
        if(columnIndex == 2 ){
          return [1,2];
        }else if( columnIndex === 3){
          return [0, 0];
        }
      }
    },
    // 格式化tableData数据
    formatSortTableData() {
      let arr = []
      this.tableData.forEach(item => {
        if (item.id) {
          const ls = this.tableData.filter(itm => {
            return itm.sortId.startsWith(item.id)
          })
          arr.push(ls)
        }
      })
      return arr;
    },
    async getDevOpsSpaceAllUser(){
      const ret = await getDevOpsSpaceAllUserListApi();
      let arr = {};
      if(ret.status === 'success'){
        ret.data.forEach((item,index)=>{
          if(item.user_type !== 1 && item.user_type !== 13){
            arr[item.id] = item.user_name;
          }
        });
      }
      this.allUser = arr;
    },
    async getChartData(params) {
      const  ret = await getDevOpsSpaceProjectPerforchartDetailApi(params);
      let drawPieSeriesData1 = [];
      let drawPieSeriesData2 = [];
      let drawPieSeriesData3 = [];
      let drawPieSeriesData4 = [];
      for (let key1 in ret.data.demand_online){
        if(key1 === '已取消'){
          drawPieSeriesData1.push({value:ret.data.demand_online['已暂停']['value'],name:'已暂停'});
        }else if(key1 === '已暂停'){
          drawPieSeriesData1.push({value:ret.data.demand_online['已取消']['value'],name:'已取消'});
        }else{
          drawPieSeriesData1.push({value:ret.data.demand_online[key1]['value'],name:key1});
        }
        //drawPieSeriesData1.push({value:ret.data.demand_online[key1]['value'],name:key1});

      }
      for (let key2 in ret.data.demand_factor){
        drawPieSeriesData2.push({value:ret.data.demand_factor[key2]['value'],name:key2});
      }
      for (let key3 in ret.data.dev_ratio){
        drawPieSeriesData3.push({value:ret.data.dev_ratio[key3]['value'],name:key3});
      }
      for (let key4 in ret.data.test_ratio){
        drawPieSeriesData4.push({value:ret.data.test_ratio[key4]['value'],name:key4});
      }
      this.myChartPie1 = this.drawPie(
          drawPieSeriesData1,
          "myChartPie1",
          "需求上线率",
      );
      this.myChartPie2 = this.drawPie(
          drawPieSeriesData2,
          "myChartPie2",
          "需求延期率",
      );
      this.myChartPie3 = this.drawPie(
          drawPieSeriesData3,
          "myChartPie3",
          "开发工时完成占比",
      );
      this.myChartPie4 = this.drawPie(
          drawPieSeriesData4,
          "myChartPie4",
          "测试工时完成占比",
      );
    },
    drawPie(seriesData, ele, title,color = []) {
      // 指定图表的配置项和数据
      const option = {
        backgroundColor: '#bdcbe8',
        title: {
          text: title,
          left: 'center',
          top: '3%',
          textStyle: {
            // color: '#fff',
            fontSize: '16px',
          },
        },
        // color:color,
        legend: {
          orient: 'vertical',
          left: 3,
          bottom: 15,
          textStyle: {
            color: '#666',
          },
          itemStyle: {
            borderRadius: 5,
            borderColor: '#fff',
            borderWidth: 1,
          },
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)',
          /* position: function (point) {
             return [point[0], point[1]]; // 将 x轴坐标向右移动 10px
           }*/
        },
        series: [
          {
            name: title,
            data: seriesData,
            type: 'pie',
            radius: '50%',
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
          },
        ],
      };
      /*
            const chartDom = document.getElementById(ele);*/
      if(ele === 'myChartPie1'){
        option.tooltip.position = function (point) {
          return [point[0], point[1]];
        };
      }
      if(ele === 'myChartPie4'){
        option.tooltip.position = function (point) {
          return [point[0] - 40, point[1]];
        };
      }
      this.$nextTick(async () => {
        const myChartPie = echarts.init(this.$refs[ele]);
        myChartPie.setOption(option);
        return myChartPie;
      })
    },
    // 排序需求列表
    setTableDateHead(arr, order) {
      let newArr = [], existDates = [], noExistDates = [];
      arr.forEach(t => {
        t[0].maxDate ? existDates.push(t) : noExistDates.push(t);
      })
      existDates.sort((a, b) => {
        return order === 'descending' ? b[0].maxDate - a[0].maxDate : a[0].maxDate - b[0].maxDate;
      })
      let pArr = existDates.concat(noExistDates);
      pArr.forEach(item => {
        let cacheIdx = 0;
        item.forEach((itm, index) => {
          if (index === 0) {
            const pi = item.filter((it, idx) => {
              if (it.id) {
                cacheIdx = idx;
                return true;
              }
            })
            itm = { ...pi[0], ...itm }
          }
          if (index === cacheIdx && cacheIdx !== 0) {
            itm = { sortId: itm.sortId, taskInfo: itm.taskInfo }
          }
          newArr.push(itm)
        })
      })
      return newArr;
    },
    // 排序事件
    async sortChange(column) {
      const { prop, order } = column;
      this.tableData = this.cacheTableData;
      if(prop === 'expect_finish_date') {
        this.tableData.sort((a, b) => {
          // ascending 升序   descending 降序  null取消（升序）
          return order === 'descending' ? Date.parse(b.expect_finish_date) - Date.parse(a.expect_finish_date) : Date.parse(a.expect_finish_date) - Date.parse(b.expect_finish_date);
        })
      }
      if(prop === 'plan_finish_date') {
        this.tableData.sort((a, b) => {
          // ascending 升序   descending 降序  null取消（升序）
          return order === 'descending' ? Date.parse(b.plan_finish_date) - Date.parse(a.plan_finish_date) : Date.parse(a.plan_finish_date) - Date.parse(b.plan_finish_date);
        })
      }
    },
    async showDetailData(row, rowList) {
      if (rowList) {
        try {
          this.loading = true;
          let params = {demandId: row.id};
          await getDevOpsSpaceProjectPerformanceDetailApi(params).then((ret) => {
            if (ret.data.length > 0) {
              this.formatTableDataDetail(ret.data, row.id);
            }
          })
          this.loading = false;

        } catch (error) {
          this.$notify({
            message: error || "数据错误",
            type: "error",
          })
          this.loading = false;
        } finally {
          this.loading = false;
        }


      }
    },
    // 格式化数据
    formatTableDataDetail(data,id) {
      this.tableData.forEach((res,index)=>{
        if(res.id == id){
          let arr = [{
            id:'',
            dps_name_zh:'',
            dp_name:'任务名称',
            dd_name:'系统',
            pm_username: '开发',
            reviewer_username: '测试',
            status_desc: '任务状态',
            expect_finish_date: 'BUG数',
            plan_finish_date:'计划提测日期',
            finish_date: '计划提交UAT日期',
            developer_delay: '开发提测日期',
            progress_rate: '提交UAT日期',
            emp1:'开发延期天数',
            emp2:'测试延期天数',
            emp3:'开发进度',
            emp4:'测试进度',
            header: true,
            type: 'header',
          }];
          data.forEach((r,k)=>{
            arr.push({
              id:(k+1) + '-' + id,
              dps_name_zh:'',
              dp_name:r.taskName,
              dd_name: r.module,
              pm_username:  r.developer.nameZh?r.developer.nameZh:'',
              reviewer_username: this.changeTest(r.test),
              status_desc: r.status,
              expect_finish_date: r.bug_num,
              plan_finish_date: r.ddt_plan_finish_time,
              finish_date: r.dtt_plan_finish_time,
              developer_delay: r.task_finish_date,
              progress_rate: r.testFinishDate,
              emp1: r.developer_delay_days,
              emp2: r.test_delay_days,
              emp3: r.task_process,
              emp4: r.average_percentage + '%',
              taskId: r.taskId,
              type:'children',
            });

          })
          this.tableData[index]['children'] = arr;
        }

      })
    },
    changeTest(data){
      let test = '';
      if(data.length >0){
        data.forEach((item)=>{
          if(item.nameZh){
            let name = item.nameZh + ' '
            test += name;
          }
        })
      }
      return test;
    },
    async SearchAll() {
      try {
        let params = {};
        for (const key in this.form) {
          const val = this.form[key];
          params[key] = this.$SELFTYPEJUDGE.isArray(val) ? val.toString() : val;
        }
        params.pageNo = 1
        params.pageSize = 9999999999999
        this.loading = true;
        const ret = await getDevOpsSpaceNewReviewListApi(params);
        this.tableDataAll = ret.data;
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        })
      } finally {
        this.loading = false;
      }
      return false;
    },
    // 弹出模板
    async showDialogVisible(type, row , back = '') {
      if (type === 'releaseing') {
        return;
      }
      let newRow = {...row};
      /*if(type === 'addTest'){
        let taskInfo = {};
        newRow = {...row,taskInfo:row};
      }*/
      if(type === 'project'){
        newRow = {name : row.project_name, id: row.project_id}
      }
      if(type === 'demand'){
        newRow = {name : row.demand_name, id: row.id}
      }
      await this.hideDialogVisible('', false)
      this.checkedInfo = newRow;
      this.dialogVisible[type] = true;
      this.back = back;
    },
    // 隐藏弹窗
    async hideDialogVisible(nextStep = '', search = true) {
      for (let key in this.dialogVisible) {
        this.dialogVisible[key] = false;
      }
      let pid = '';
      if(nextStep === 'demand'){
        pid = this.checkedInfo.id;
      }
      if (nextStep && (typeof(nextStep) === 'string')) {
        const params = nextStep === 'demand' ? { demandName: this.checkedInfo?.id} : ''
        const ret = await getDevOpsSpaceNewReviewListApi(params);
        const tableData = ret.data || [];
        this.checkedInfo = tableData[0];
        this.checkedInfo.next = (nextStep === 'demand')
        if(nextStep === 'demand'){
          this.checkedInfo = {id:pid};
        }
        this.$nextTick(() => {
          this.checkedInfo && (this.dialogVisible[nextStep] = true);
        })
      } else {
        search && await this.formSearch()
      }
    },
    async getSystem() {
      let arr = {};
      await getDevOpsSpaceSystemApi().then((res) => {
        res.data.forEach((item)=>{
          arr[item.id] = item.nameZh;
        });
      });
      this.allSystem = arr;
      let team = {};
      await getDevOpsSpaceTeamListApi().then((ret)=>{
        ret.data.forEach((item)=>{
          team[item.id] = item.name;
        });
      })
      this.teamList = team;
    },
    getProjectList(systemId){
      getDevOpsSpaceFindProjectNameApi({isEffective:true,systemId: systemId}).then(res=>{
        if(res.data){
          this.projectList = res.data;
        }
      })
    },
    // 分页
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
      setStorage('pageSize', val, 'localStorage')
      this.formSearch();
    },
    // 分页事件
    handleCurrentChange(val) {
      this.formSearch();
    },
    changeReset(){
      this.form.status = '';
      this.form.reviewId = '';
      this.form.systemId = '';
      this.form.projectName = '';
      this.form.demandName = '';
      this.form.reviewId = '';
      this.form.serach_time = '';
      this.form.reviewed_status = '';
    },
    linkFrom(tabid,typeId,busId = ''){
      // let url = `${window.location.origin}/#/devOpsProducerSpace?tabid=${tabid}&${typeId}=${busId}`;
      let url = `${window.location.origin}/Home/devOpsTaskSpace/allTask?${typeId}=${busId}`;
      //proId pid tid
      //项目
      if(typeId === 'proId'){
        url = `${window.location.origin}/Home/devOpsProjectSpace/project?${typeId}=${busId}`;
      }
      //需求
      if(typeId === 'pid'){
        url = `${window.location.origin}/Home/devOpsDemandSpace/demand?${typeId}=${busId}`;
      }
      //任务
      if(typeId === 'tid'){
        url = `${window.location.origin}/Home/devOpsTaskSpace/devTask?${typeId}=${busId}`;
      }
      window.open(url)
    },
    fileExport() {
      let url = `${window.location.origin}/devops/space/reporter/export?source_type=project&project_action=list`;
      for (const key in this.form) {
        const val = this.form[key];
        url += `&${key}=${this.$SELFTYPEJUDGE.isArray(val) ? val.toString() : val}`;
      }
      const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
      url += `&pageNo=${this.currentPage}&pageSize=${this.pageSize}&username=${username}`;
      window.location.href = url;
    },
    searchTime(type){
      if(type === 1){
        //过去一周
        this.form.createStartDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 00:00:00")).getTime() - 60 * 60 * 24 * 1000 * 7);
        this.form.createEndDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 23:59:59")).getTime());
      }
      if(type === 2){
        //过去两周
        this.form.createStartDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 00:00:00")).getTime() - 60 * 60 * 24 * 1000 * 7 * 2);
        this.form.createEndDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 23:59:59")).getTime());
      }
      if(type === 3){
        //过去一个月
        this.form.createStartDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 00:00:00")).getTime() - 60 * 60 * 24 * 1000 * 30);
        this.form.createEndDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 23:59:59")).getTime());
      }
      if(type === 4){
        //过去三个月
        this.form.createStartDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 00:00:00")).getTime() - 60 * 60 * 24 * 1000 * 30 * 3);
        this.form.createEndDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 23:59:59")).getTime());
      }
      if(type === 5){
        //过去半年
        this.form.createStartDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 00:00:00")).getTime() - 60 * 60 * 24 * 1000 * 182);
        this.form.createEndDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 23:59:59")).getTime());
      }
      if(type === 6){
        //过去一年
        this.form.createStartDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 00:00:00")).getTime() - 60 * 60 * 24 * 1000 * 365);
        this.form.createEndDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 23:59:59")).getTime());
      }
      if(type === 7){
        //新增 本周
        let nowday = new Date().getDay();
        let day = nowday || 7;
        this.form.createStartDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 00:00:00")).getTime() - 60 * 60 * 24 * 1000 * (day - 1));
        this.form.createEndDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 23:59:59")).getTime());
      }
      this.form.serach_demand_time = [this.form.createStartDate,this.form.createEndDate];
      this.formSearch('reset','search')
    },
    changeTimeDate(timestamp){
      let dateObj = new Date(timestamp);
      // 提取所需的年、月、日等信息
      let year = dateObj.getFullYear();
      let month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
      let day = dateObj.getDate().toString().padStart(2, '0');
      // 构造最终的日期/时间字符串
      let formattedTime = `${year}-${month}-${day}`;
      return formattedTime;
    },
    // 将英文名字转为中卫
    formatEnToUtf8,
    formatEnToUtf8NoEn,
    // 毫秒值转 YYYY-MM-DD HH:mm:ss
    formatTimeToDate
  },
};
</script>
<style lang="scss">
.devOps_producerSpaceProjectReport {

  .link_svg {
    position: absolute;
    left: -96px;
    top: 2px;
    transform: rotate(90deg);
    cursor: pointer;
  }

  .table_text_click {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .table_text_click_new {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }



  .table_text_no_click {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .dialog-footer .el-button {
    font-weight: bold;
    margin-left: 0;
    margin-right: 10px;
  }

  .form_warp .el-form-item {
    margin-bottom: 6px;
  }

  padding-top: 10px;

  // #region select
  .el-select__tags {
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE 10+ */
  }

  .el-select__tags::-webkit-scrollbar {
    display: none;
    /* Chrome Safari */
  }

  .el-input__inner {
    margin-left: -5px;
  }

  // #endregion select
  .priority_style {
    border-radius: 5px;
    text-align: center;
    width: fit-content;
    padding: 0 5px;
    margin: auto;
  }

  .el-dialog__header {
    font-weight: bold;
  }

  .el-form-item__label {
    font-weight: bold;
  }

  .devOpsSpace_page {
    // text-align: right;
    display: flex;
    justify-content: flex-end;
    margin-right: 20px;

    .demonstration {
      font-size: 13px;
      color: #606266;
      line-height: 1;
      margin-top: 25px;
      margin-right: 10px;
    }
  }
  .chart_single_div {
    padding: 0px 20px !important;
  }
}

/* #region 滚动条部分 */
.el-table__body-wrapper {
  scrollbar-width: thin;
  scrollbar-color: skyblue #eee;
}

.el-table__body-wrapper::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 10px;
}

.el-table__body-wrapper::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent);
}

.el-table__body-wrapper::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}

.tips-message {
  max-height: 480px;
  overflow-y: auto;
  white-space: pre-wrap;
  background: #f1fbec;
  scrollbar-width: thin;
  scrollbar-color: skyblue #eee;
}

.websocket_style {
  background-color: #333;
  color: #fefefe;
  padding: 8px;

  a {
    color: #e6a23c;
  }
}

.tips-message::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 16px;
}

.tips-message::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent);
}

.tips-message::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}

/* #endregion 滚动条部分 */

.table_options_warp {
  position: absolute;
  z-index: 4;
  left: 20px;
  top: 22px;
  width: 20px;
  cursor: pointer;
}
.tag-table{
  margin:15px 10px;
}
.review_centert{
  color:#fff;
  padding: 4px;
  border-radius: 10px;
}
.not_reviewed{
  background:#409EFF;
  opacity: 0.75;
}
.under_review{
  background:#409EFF;
}
.reviewed{
  background:#11B45C;
}
.history_reviewed{
  background:#333333;
}
.devOps_producerSpaceProjectReport .el-form-item__label {
  font-weight: bold;
  font-size: 12px;
}
/* /deeep/样式穿透*/
/*1.取消原本展开的旋转动效*/
.devOps_producerSpaceProjectReport .el-table__expand-icon{
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
}
/*2.展开按钮未点击的样式是加号带边框*/
.devOps_producerSpaceProjectReport .el-table__expand-icon .el-icon-arrow-right:before{
  content: "\e723";
  padding: 1px;
  font-size: 17px;
}
/*2.按钮已点击展开之后的样式是减号带边框*/
.devOps_producerSpaceProjectReport .el-table__expand-icon--expanded .el-icon-arrow-right:before{
  content: "\e722";
}
#myChartPie1,
#myChartPie2,
#myChartPie3,
#myChartPie4 {
  height: 200px;
}
.project-box{
  height: 30vh;
  position: relative;
  //overflow-y: scroll;
}
.project-box-c{
  height: 58vh;
  position: relative;
  //overflow-y: scroll;
}
/*.project-box::-webkit-scrollbar {
  !*滚动条整体样式*!
  width: 10px;
  !*高宽分别对应横竖滚动条的尺寸*!
  height: 16px;
}*/
/*
.project-box::-webkit-scrollbar-thumb {
  !*滚动条里面小方块*!
  border-radius: 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent);
}

.project-box::-webkit-scrollbar-track {
  !*滚动条里面轨道*!
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}*/
.devOps_producerSpaceProjectReport .el-table__header{
  background:#f3f3f3 !important;
}
.devOps_producerSpaceProjectReport .el-table__header tr{
  background:#f3f3f3 !important;
}
.chooseTime .el-form-item__content{
  width: 100%;
}
</style>
